// extracted by mini-css-extract-plugin
export default {"badgeContent":"ActionControlsFab_badgeContent__AQBt0"};